exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".setting-header[data-v-4cd6d83b]{background-color:#fbfbfb}.setting-body[data-v-4cd6d83b]{background-color:#fdfdfd}.gravatar-pic[data-v-4cd6d83b]{border-radius:50%;width:100px;display:initial;margin-bottom:6px}.rg-pic-wrapper .rg-pic-uploader-wrapper[data-v-4cd6d83b]{display:none}.rg-pic-wrapper:hover .rg-pic-uploader-wrapper[data-v-4cd6d83b]{display:block}", ""]);

// exports
